import { render, staticRenderFns } from "./MomentSoldListComponent.vue?vue&type=template&id=36658a60&scoped=true&"
import script from "./MomentSoldListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentSoldListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentSoldListComponent.vue?vue&type=style&index=0&id=36658a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36658a60",
  null
  
)

export default component.exports